import { IAudioBookmark } from '../interfaces/i-audio-bookmark';
import { AudioSurah } from './audio-surah';
import { Reciter } from './reciter';

export class AudioBookmark {
  suraGuid: string;
  timing?: number;
  audioSurah?: AudioSurah;
  reciter?: Reciter;
  constructor(data: IAudioBookmark) {
    this.suraGuid = data.suraID;
    this.timing = data.timing ? data.timing : undefined;
    this.audioSurah = data.audioSurah
      ? new AudioSurah(data.audioSurah)
      : undefined;
    this.reciter = data.audioSurah?.reciter
      ? new Reciter(data.audioSurah.reciter)
      : undefined;
  }
}
